import ISubjects from '../@types/ISubjects';

interface ISubject {
  title: string,
  subtitle?: string
  parentTitle?: string
  grandParentTitle?: string
}

const getContentPageTitle = (subjects: ISubjects[], url: string) => {
  const pagesTitles = new Map<string, ISubject>();

  subjects.forEach((subject) => {
    if (subject.children && subject.children.length > 0) {
      subject.children.forEach((childSubject) => {
        pagesTitles.set(
          `${subject.slug}/${childSubject.slug}`,
          {
            title: childSubject.title,
            subtitle: childSubject.subtitle || '',
            parentTitle: subject.title,
          }
        );

        if (childSubject.children && childSubject.children.length > 0) {
          childSubject.children.forEach((grandChildSubject) => {
            pagesTitles.set(
              `${subject.slug}/${childSubject.slug}/${grandChildSubject.slug}`,
              {
                title: grandChildSubject.title,
                subtitle: grandChildSubject.subtitle || '',
                parentTitle: childSubject.title,
                grandParentTitle: subject.title,
              }
            );
          });
        }
      });
    }

    pagesTitles.set(
      `${subject.slug}/inicio`,
      {
        title: subject.title,
        subtitle: subject.subtitle || '',
      }
    );
  });

  return pagesTitles.get(url);
};

export default getContentPageTitle;
